document.addEventListener('DOMContentLoaded', function() {

  function getWishlist() {
    return JSON.parse(localStorage.getItem('wishlist')) || [];
  }

  function saveWishlist(items) {
    localStorage.setItem('wishlist', JSON.stringify(items));
    updateWishlistCount();
  }

function updateWishlistCount() {

  const count =
    JSON.parse(localStorage.getItem('wishlist') || '[]').length;

  const countElement =
    document.querySelector('.wishlist-count-text');

  if (countElement) {
    countElement.textContent = count;
  }

  const bubble =
    document.querySelector('.wishlist-bubble');

  if (bubble) {
    bubble.style.display = count > 0 ? 'flex' : 'none';
  }

}

window.updateWishlistCount = updateWishlistCount;

window.updateWishlistCount = updateWishlistCount;

  document.addEventListener('click', function(e) {

    const btn = e.target.closest('.wishlist-btn');
    if (!btn) return;

    e.preventDefault();

    const handle = btn.dataset.handle;

    let wishlist = getWishlist();

    if (wishlist.includes(handle)) {
      wishlist = wishlist.filter(item => item !== handle);
      btn.classList.remove('active');
    } else {
      wishlist.push(handle);
      btn.classList.add('active');
    }

    saveWishlist(wishlist);
  });

  document.querySelectorAll('.wishlist-btn').forEach(btn => {
  const handle = btn.dataset.handle;

  if (getWishlist().includes(handle)) {
    btn.classList.add('active');
  }
});

updateWishlistCount();

document.addEventListener('cart:update', function() {

  setTimeout(() => {

    updateWishlistCount();

  }, 260);

});

});